module.exports = __webpack_public_path__ + "static/logo-4b69c492393ee424ff84572b943b0ec3.svg";